import script from "./SfxImageViewerManager.vue?vue&type=script&setup=true&lang=ts"
export * from "./SfxImageViewerManager.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__
import QCarousel from 'quasar/src/components/carousel/QCarousel.js';
import QCarouselSlide from 'quasar/src/components/carousel/QCarouselSlide.js';
import QImg from 'quasar/src/components/img/QImg.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCarouselControl from 'quasar/src/components/carousel/QCarouselControl.js';
import QFile from 'quasar/src/components/file/QFile.js';
import QList from 'quasar/src/components/item/QList.js';import TouchPan from 'quasar/src/directives/touch-pan/TouchPan.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCarousel,QCarouselSlide,QImg,QIcon,QCarouselControl,QFile,QList});qInstall(script, 'directives', {TouchPan});
